<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Список пользователей</h3>
              <div class="card-tools">
                <button type="button" class="btn btn-sm btn-primary" @click="$refs.modal.openModal();clearForm()">
                  <i class="fa fa-plus-square"></i>
                  Добавить пользователя
                </button>
              </div>
            </div>

            <div class="card-body table-responsive p-0">
              <search-widget  ref="search" @my-event="getResults">

                    <div class="form-group col-4">
                      <label>Имя</label>
                      <input v-model="search.name" type="text" name="name"
                             class="form-control">
                    </div>

                    <div class="form-group col-6">
                      <label>Email</label>
                      <input v-model="search.email" type="text" name="email"
                             class="form-control" >
                    </div>

                <div class="form-group ">
                  <button type="button" class="btn btn-sm btn-success" @click="getResults(); searchWid();  $refs.search.closesearch()">
                  <i class="fa fa-search "></i>Поиск
                </button>
                </div>

              </search-widget>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th @click="getResults(current_page, 'id')">id
                    <button :tabindex="-1" aria-label="Sort " title="Sort "
                            :class="[ (sort.id=='ASC') ? 'transform' : 'transformold' ]"
                            class="gridjs-th gridjs-th-sort"></button>
                  </th>
                  <th @click="getResults(current_page, 'name')">Имя
                    <button :tabindex="-1" aria-label="Sort " title="Sort "
                            :class="[ (sort.family=='ASC') ? 'transform' : 'transformold' ]"
                            class="gridjs-th gridjs-th-sort"></button>
                  </th>
                  <th @click="getResults(current_page, 'phone')">Телефон
                    <button :tabindex="-1" aria-label="Sort " title="Sort "
                            :class="[ (sort.phone=='ASC') ? 'transform' : 'transformold' ]"
                            class="gridjs-th gridjs-th-sort"></button>
                  </th>
                  <th @click="getResults(current_page, 'email')">Логин
                    <button :tabindex="-1" aria-label="Sort " title="Sort "
                            :class="[ (sort.email=='ASC') ? 'transform' : 'transformold' ]"
                            class="gridjs-th gridjs-th-sort"></button>
                  </th>
                  <th @click="getResults(current_page, 'cat')">Роль
                    <button :tabindex="-1" aria-label="Sort " title="Sort "
                            :class="[ (sort.cat=='ASC') ? 'transform' : 'transformold' ]"
                            class="gridjs-th gridjs-th-sort"></button>
                  </th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr  v-if="users.data && users.data.length>0" v-for="user in users.data" :key="user.id">
                  <td>{{ user.id }}</td>
                  <td class="text-capitalize">{{ user.family }} {{ user.name }}  {{ user.surname }}</td>

                  <td>{{ user.phone }}</td>
                  <td>{{ user.email }}</td>
                  <td><span v-if="user.rolename">
										{{user.rolename }}
									</span>
										</td>
                  <td style="text-align: end">
                    <a href="#" @click="editModal(user);$refs.modal.openModal();">
                      <i class="fa fa-edit blue"></i>
                    </a>
                    <a href="#" @click="deleteUser(user)">
                      <i class="fa fa-trash red"></i>
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
            <div class="card-footer">
              <pagination :data="users" @pagination-change-page="getResults" :limit="5">
                <span slot="prev-nav">&lt; Назад</span>
                <span slot="next-nav">Вперед &gt;</span>
              </pagination>
            </div>
          </div>
          <!-- /.card -->
        </div>
      </div>

<!--      <div v-if="!$gate.isAdmin()">-->
<!--        <not-found></not-found>-->
<!--      </div>-->
      <!-- Modal -->
      <right-modal-widget  v-bind:id="'production-edit-modal'" v-bind:title="!editmode?'Создать запись':'Редактировать запись'" ref="modal">
            <!-- <form @submit.prevent="createUser"> -->
            <form @submit.prevent="editmode ? updateUser() : createUser()">
              <div class="modal-body">
                <div class="form-group">
                  <label>Фамилия</label>
                  <input v-model="form.family" type="text" name="family"
                         class="form-control" :class="{ 'is-invalid': form.errors.has('family') }">
                  <has-error :form="form" field="family"></has-error>
                </div>
                <div class="form-group">
                  <label>Имя</label>
                  <input v-model="form.name" type="text" name="name"
                         class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                  <has-error :form="form" field="name"></has-error>
                </div>
                <div class="form-group">
                  <label>Отчество</label>
                  <input v-model="form.surname" type="text" name="surname"
                         class="form-control" :class="{ 'is-invalid': form.errors.has('surname') }">
                  <has-error :form="form" field="surname"></has-error>
                </div>
                <div class="form-group">
                  <label>Email</label>
                  <input v-model="form.email" type="text" name="email"
                         class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                  <has-error :form="form" field="email"></has-error>
                </div>
                <div class="form-group">
                  <label>Телефон</label>
                  <input v-model="form.phone" type="text" name="phone"
                         class="form-control" :class="{ 'is-invalid': form.errors.has('phone') }">
                  <has-error :form="form" field="phone"></has-error>
                </div>

                <div class="form-group">
                  <label>Пароль</label>
                  <input v-model="form.password" type="password" name="password"
                         class="form-control" :class="{ 'is-invalid': form.errors.has('password') }"
                         autocomplete="false">
                  <has-error :form="form" field="password"></has-error>
                </div>

                <div class="form-group">
                  <label>Роль</label>
                  <select name="role" v-model="form.roleid" id="role" class="form-control"
                          :class="{ 'is-invalid': form.errors.has('role') }">
                    <option value="">Выберете роль</option>
                    <option value="1">Администратор</option>
                    <option value="2">Менеджер</option>
                    <option value="3">Клиент</option>
                  </select>
                  <has-error :form="form" field="role"></has-error>
                </div>
              </div>
              <div class="modal-footer">

                <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
                <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
              </div>
            </form>
      </right-modal-widget>
    </div>
  </section>
</template>

<script>
import SearchWidget from "../../widgets/SearchWidget.vue";
export default {
  components: {SearchWidget},
  data() {
    return {
      editmode: false,
      modalDialogState: false,
      users: {},
      form: new Form({
        id: '',
        family: '',
        name: '',
        surname: '',
        email: '',
        phone: '',
        role: '',
        login: '',
        password: '',
      }),
      sort: {
        id: 'ASC',
        family: 'ASC',
        phone: 'ASC',
        email: 'ASC',
        role: 'ASC',
      },
      search: {
        id: '',
        name: '',
        email: '',
        login: '',
        role: '',
      },
      role: {
        1: 'Администратор',
        2: 'Менеджер',
        3: 'Клиент',
      },
      close: true,
      current_page: 1,
      sortable: '',
      urls: {
        getdata: "api/user?page=",
        update: "api/user/update",
        create: "api/user/",
        delete: "api/user/",
      },
    }
  },
  methods: {
    toastError(errors){
      if (errors && errors.length == 1){
        Toast.fire({
          timer: 5000,
          icon: 'error',
          title: errors
        })
      }else{
        var result = Object.keys(errors).map((key) => [errors[key]]);
        for (var i = 0; i < result.length; i++){
          Toast.fire({
            timer: 5000,
            icon: 'error',
            title: result[i][0][0]
          })
        }
      }
    },
    validateErrors(errors){
      if(errors.response &&  errors.response.status==401){
        var error=[];
        error[0]='Истекло время сессии, войдите повторно';
        this.toastError(error);
        window.location.href = "login";
      }
      this.toastError(errors.response.data.errors);
    },

    clearForm() {
      this.form.id = '';
      this.form.family = '';
      this.form.name = '';
      this.form.surname = '';
      this.form.email = '';
      this.form.phone = '';
      this.form.password = '';
      this.form.roleid = '';
      return;
    },
    fsort(name) {
      if (this.sort[name] == 'ASC') {
        this.sort[name] = 'DESC';
      } else {
        this.sort[name] = 'ASC'
      }
    },
    async getResults(page, sort) {
      this.fsort(sort);
      if (page == undefined) {
        page = this.current_page;
      } else {
        this.current_page = page;
      }
      this.$Progress.start();
      axios.get(this.urls.getdata + page, {
        params: {
          sort: sort,
          sortable: this.sortable,
          search: this.search
        }
      })
          .then(({data}) => (
              this.users = data.data,
              this.sortable = data['message']
          ))
          .catch((errors) => {
            this.toastError(errors.response.data.errors);
          });

      this.$Progress.finish();
    },
    editModal(user) {
      this.editmode = true;
      this.clearForm();
      this.form.reset();
      this.form.fill(user);
     // console.log(this.links);
    },
    updateUser() {
      //var category='';
      this.$Progress.start();
      let formData = new FormData();
      formData.append('file', this.file);
        axios.post(this.urls.create,formData, {
           params:{
              id: this.form.id,
               email: this.form.email,
              name: this.form.name,
             surname: this.form.surname,
             family: this.form.family,
             phone: this.form.phone,
              password: this.form.password,
              role: this.form.roleid,
              },
            headers: {
               'Content-Type': 'multipart/form-data'
            }
          })
          .then((response) => {
            // success
            $('#addNew').modal('hide');
            Toast.fire({
              icon: 'success',
              title: response.data.message
            });
            this.getResults();
            this.$Progress.finish();
            this.$refs.modal.closeModal();
          })
            .catch((errors) => {
              this.validateErrors(errors);
              this.$Progress.fail();
            });
    },
    newModal() {
      this.editmode = false;
      this.form.reset();
      $('#addNew').modal('show');
    },
    deleteUser(data) {
      Swal.fire({
        title: 'Вы уверены',
        text: "Что хотите удалить пользователя " + data.name + "?",
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        cancelButtonText: 'Отмена',
        confirmButtonText: 'Да, уверен!'
      }).then((result) => {
        // Send request to the server
        if (result.value) {
         // axios.delete('api/user/' + user.id)
          this.form.delete(this.urls.delete + data.id)
          .then(() => {
            Swal.fire(
                'Пользователь ' + data.name + '',
                'Удален!',
                'success'
            );
            this.getResults();
          })
              .catch((errors) => {
                this.$Progress.fail();
                this.validateErrors(errors);
          });
        }
      })
    },
    createUser() {
      let formData = new FormData();
      formData.append('file', this.file);
      // console.log('Editing data');
      axios.post(this.urls.create,formData, {
        params:{
          id: this.form.id,
          name: this.form.name,
          surname: this.form.surname,
          family: this.form.family,
          email: this.form.email,
          phone: this.form.phone,
          password: this.form.password,
          role: this.form.role,
          login: this.form.login,
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then((response) => {
            $('#addNew').modal('hide');
            Toast.fire({
              icon: 'success',
              title: response.data.message
            });
            this.getResults();
            this.$Progress.finish();
            this.$refs.modal.closeModal();
          })
          .catch((errors) => {
            this.validateErrors(errors);
            this.$Progress.fail();
          });
    },

    resSearchCity(value)
    {
      this.form.city=value;
      $(".search_result_city").fadeOut();
    },


  },
  mounted() {
    this.$Progress.start();
    this.getResults();
    this.$Progress.finish();

  },
  computed: {
    modal: function(){
      if( this.modalDialog == 1 ){
        return  true;
      }
      return false;
    }
  },
  watch: {
    // 'search': function(){
    //   if (this.search.cat==1){
    //     this.search.cat='Legal';
    //   } if (this.search.cat==2){
    //     this.search.cat='Business';
    //   } if (this.search.cat==3){
    //     this.search.cat='IT';
    //   }
    //   console.log(this.search);
    //   this.$refs.search.data(this.search)
    // }
  }
}
</script>

<style>
.search_form {
  font-size: 16px;
  background: #FFF;
  /*border: 1px #ccc solid;*/
  width: auto;
  border-radius: 4px;
  max-height: 30em;
  overflow-y: scroll;
  /*margin-left: -2em;*/
}
.search_form li:hover {
  background: #368fdb;
  color: white;
}
.table-hover  th::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 5px;
  right: 5px;
  height: 3px;
  background: #c4e4ff;
}
.swal2-container {
    z-index: 9999;
}
/*.vs--searchable .vs__dropdown-toggle {*/
/*  width: 13em;*/
/*}*/
</style>
